// extracted by mini-css-extract-plugin
export default {"media":"media__3FoSr"};